import React, { useState } from "react";

import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../context/StateContext";
import { WidgetFilter } from "../../../../models/widget.filter";
import DashboardService from "../../../../services/dashboard.service";
import { formatThousandsWithComma } from "../../../../util/formatThousandsWithComma";
import { useStyles } from "./styles";

/** Default Functional Component */
export default function QuotedVolume({ filterInfo }: { filterInfo: WidgetFilter }) {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const [total, setTotal] = useState<string>("0");
  const [measurement, setMeasurement] = useState<string>("");

  useQuery(
    ["dashboard.quote.volume", filterInfo],
    () =>
      DashboardService.getQuoteVolume({
        dateFrom: filterInfo?.dateFrom,
        dateTo: filterInfo?.dateTo,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response) => {
        if (response && response.data) {
          setMeasurement(response?.data?.measurement || "");
          setTotal(response?.data?.total || "");
        }
      },
      enabled: !!currentUser?.companyId,
    }
  );

  const renderMeasurement = () => {
    if (measurement) {
      return ` (${measurement?.toUpperCase()})`;
    }

    return null;
  };

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} gutterBottom component="div" data-cy="quoteVolume">
        {translate("quotedVolume")}
        {renderMeasurement()}
      </Typography>

      <Typography
        className={classes.lblFigures}
        variant="h5"
        component="h2"
        align="left"
        data-cy="quoteVolumeTotal"
      >
        {formatThousandsWithComma(total)}
      </Typography>
    </Box>
  );
}
